import React from 'react';
import { useTranslation } from 'react-i18next';

import { LinkAction, LinkActionType, LinkActionTheme } from '../../styles';
import { goQuitterParcours } from '../../hooks/navigation/useRoutes/useRoutes';
import { NavigationPlacement } from '../../components';
import { getRetourUrl } from '../../utils';

export const Navigation: React.FC<unknown> = () => {
    const [t] = useTranslation('InteretRetard');

    const handleCancel = () => {
        goQuitterParcours();
    };

    const retourUrl = getRetourUrl();

    return (
        <NavigationPlacement
            renderReturnButton={
                <LinkAction
                    href={retourUrl}
                    type={LinkActionType.return}
                    theme={LinkActionTheme.green}
                    dataTestId="navigation-quit-button"
                    onClick={handleCancel}
                >
                    {t('return_button')}
                </LinkAction>
            }
        ></NavigationPlacement>
    );
};
